<template>
  <v-app style="background: #eee">
    <nav class="ma-3">
      <v-layout justify-center>
        <v-flex xs12 sm6 md4>
          <center>
            <v-card flat color="#eee">
              <v-form class="mt-4">
                <v-autocomplete v-model="searchCategory" :items="categories" label="Category" persistent-hint color="black">
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition mode="out-in"></v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
              </v-form>
              <v-btn large round @click="submitQuery" color="#35455c" dark>Search</v-btn>
            </v-card>
          </center>
        </v-flex>
      </v-layout>
			<v-divider class="ma-3"/>
			<v-layout row wrap>
        <v-flex v-for="doc in docs" v-if="checkOwnId(doc.data().posted_by.uid)" xs12 sm6 md4>
          <div class="mr-4 ml-4">
            <BuyCard
              :item_name="doc.data().item_name"
              :category="doc.data().category"
              :marked_price="Number(doc.data().marked_price)"
              :photos="doc.data().photos"
              :posted_by="doc.data().posted_by"
              :postId="doc.id"
              :alreadyInterested="checkAlreadyInterested(doc)"
              :alreadyAccepted="checkAlreadyAccepted(doc)"
              :interested="doc.data().interested"
              :accepted="doc.data().accepted"
            />
          </div>
        </v-flex>
      </v-layout>
    </nav>
  </v-app>
</template>

<script>
import BuyCard from '@/components/BuyCard.vue'
import firebase, { functions } from 'firebase'

export default {
	components: {
		BuyCard
	},
  data() {
    return {
      listener: null,
      docs: [],
      searchCategory: '',
      categories: [
        "Bicycle",
        "Books",
        "Electronics",
        "Furniture",
        "Lab Equipment",
        "Sports Equipment",
        "Other",
      ]
    };
  },

  methods: {
    checkAlreadyInterested(doc){
      var vm = this;
      var uid = firebase.auth().currentUser.uid;
      var result = false;
      for(var element of doc.data().interested) {
        if(element.uid==uid){
          result = true;
        }
      }
      return result;
    },
    checkAlreadyAccepted(doc){
      var vm = this;
      var uid = firebase.auth().currentUser.uid;
      var result = false;
      for (var element of doc.data().accepted){
        if (element.uid==uid) {
          result = true;
        }
      }
      return result;
    },
    submitQuery(){
      var vm = this;
      const db = firebase.firestore();
      vm.listener();
      db.collection('posts_buy')
      .where('category', '==', vm.searchCategory)
      .where('post_closed','==',false)
      .onSnapshot(function(querySnapshot){
        vm.docs = querySnapshot.docs;
      })
    },

    checkOwnId: function(id) {
      return id != firebase.auth().currentUser.uid;
    },
  },

  mounted() {
    const db = firebase.firestore();
    var vm = this;
    vm.listener = db.collection('posts_buy').where("post_closed","==",false).onSnapshot(function(querySnapshot){
      vm.docs = querySnapshot.docs;
    })
  },

  beforeDestroy(){
    var vm = this;
    vm.listener();
  },
};
</script>
